exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.card[data-v-47f625f9] {\n  position: relative;\n  min-height: 95px;\n  max-width: 375px;\n  padding: 20px;\n  background: #FFFFFF;\n  color: #222c3c;\n  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);\n  border-radius: 5px;\n}\n.card .textZone[data-v-47f625f9] {\n    padding-right: 5px;\n}\n.card.no-info[data-v-47f625f9] {\n    width: 350px;\n}\n.values[data-v-47f625f9] {\n  font-size: 16px;\n  margin-top: 15px;\n}\n.account-card-sub-title[data-v-47f625f9] {\n  color: #787878;\n  font-size: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-47f625f9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/myPlan/AccountDetails.vue
// module id = 2557
// module chunks = 0